import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import type { PdpProduct } from 'components/discovery/pdp/typing/pdp-product.js'

export const PRODUCT_SET_API = Symbol('PRODUCT_SET_API')

export class ProductSetGetRequest {
  endpointUrl: string
  method = 'GET' as const
  headers: HeadersInit = { Accept: 'application/json' }

  constructor(endpointUrl: string) {
    this.endpointUrl = endpointUrl
  }
}

export interface ProductSetAPI {
  getProducts(request: ProductSetGetRequest): Promise<PdpProduct[]>
}

@registerDependency(FAKE, PRODUCT_SET_API)
export class FakeProductSetAPI implements ProductSetAPI {
  requests: ProductSetGetRequest[] = []
  productsData: PdpProduct[] = []
  pending = false

  getProducts(request: ProductSetGetRequest): Promise<PdpProduct[]> {
    this.requests.push(request)
    if (this.pending) return new Promise(() => {})
    return Promise.resolve(this.productsData)
  }
}

@registerDependency(REAL, PRODUCT_SET_API)
export class RealProductSetAPI implements ProductSetAPI {
  async getProducts(request: ProductSetGetRequest): Promise<PdpProduct[]> {
    const response = await fetch(request.endpointUrl, { method: request.method, headers: request.headers })
    return response.json()
  }
}
